



















import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';

@Component({
    components: {
        layout,
    },
})
export default class Forbidden extends Vue {}
